// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ItemDetail } from './item-detail';
import { ItemReplacementStatus } from './item-replacement-status';
import { ItemReplacementType } from './item-replacement-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ItemReplacement extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** String(12) key FK itemDetail */
  itemDetailId!: string;
  /** DateTimeOffset */
  crtnTs!: Date;
  /** String(4) */
  crtnUserInit!: string;
  /** String(10) FK itemReplacementStatus */
  itemReplacementStatusId!: string;
  /** String(10) FK itemReplacementType */
  itemReplacementTypeId!: string;
  /** FK itemDetailId */
  itemDetail!: ItemDetail;
  /** FK itemReplacementStatusId */
  itemReplacementStatus!: ItemReplacementStatus;
  /** FK itemReplacementTypeId */
  itemReplacementType!: ItemReplacementType;
}

